









































import { Component, Mixins, Watch } from 'vue-property-decorator'
import { HistoryViewMixin } from '@/mixins'
import { TRANSFORMERS, TRANSFORMER, ITransformerSettings } from '@/helpers/transformer'
import { Track } from '@/classes/track'
import { USAGE_STAT_FEATURES } from '@/system/usage-stats'
import { sentryException } from '@/system/sentry'

enum VIEWS {
  Start = 'start',
  Transform = 'transform'
}

@Component({
  components: {
    Transformers: require('./Transformers').default,
    TransformerOptions: require('./TransformerOptions').default,
    Grid: require('./Grid').default
  }
})
export default class Transform extends Mixins(HistoryViewMixin) {
  view: VIEWS = VIEWS.Start
  loading: boolean = false

  transformer: TRANSFORMERS | null = null
  selectedTracks: Track[] = []

  settings: ITransformerSettings = {
    values: []
  }

  get description(): string {
    if (!this.transformer) return ''

    return TRANSFORMER[this.transformer].description
  }

  get valid(): boolean {
    return !!this.transformer && TRANSFORMER[this.transformer].isValid(this.settings)
  }

  get disabled(): boolean {
    return !this.valid || this.selectedTracks.length === 0
  }

  get tracks(): Track[] {
    return this.$store.getters['library/selectedTracks']
  }

  back() {
    this.reset()

    window.history.back()
  }

  async confirm() {
    this.loading = true

    try {
      await this.$store.dispatch('transformer/execute', {
        tracks: this.selectedTracks,
        transformer: this.transformer,
        settings: this.settings
      })

      if (this.transformer) {
        this.$buefy.notification.open(TRANSFORMER[this.transformer].notification || 'Edit complete')
      }

      this.reset()

      window.addUsageStat(USAGE_STAT_FEATURES.Transformer, 'confirm', this.transformer as string)

      if (this.transformer === TRANSFORMERS.TrackDelete) {
        await this.$router.replace({
          name: 'track editor'
        })
      } else {
        this.view = VIEWS.Start
      }
    } catch (error) {
      sentryException(error)
    } finally {
      this.loading = false
    }
  }

  reset() {
    this.settings = {
      values: []
    }

    this.selectedTracks = []
  }

  async created() {
    this.reset()

    if (this.tracks.length === 0) {
      await this.$router.push({
        name: 'track editor'
      })
    }
  }

  @Watch('transformer')
  watchTransformer() {
    if (this.transformer) {
      this.goToView(VIEWS.Transform)
    }
  }

  @Watch('view')
  watchView() {
    if (this.view === VIEWS.Start) {
      this.transformer = null
    }
  }
}
